import { AddModalProps } from '../../types';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { useCreateAgreementMagazineMutation } from '@partiu/api/dashboard/hooks.ts';
import { Button, HStack, Spacer, Text, VStack } from '@chakra-ui/react';
import { FaPlus } from 'react-icons/fa6';

export function MagazineForm({ options, onClose }: AddModalProps<number>) {
  const { id } = useTheme();
  const mutation = useCreateAgreementMagazineMutation(options);

  return (
    <VStack>
      <Text>
        Ao clicar no botão abaixo, será iniciado um processo em nossos servidores para gerar a revista da empresa. Essa
        tarefa pode demorar diversos minutos, enquanto estiver sendo gerada, aparecerá na página com o nome
        "Gerando...". Apenas uma revista pode ser gerada por vez.
      </Text>
      <HStack width={'100%'}>
        <Spacer />
        <Button isLoading={mutation.isLoading} variant="ghost" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          leftIcon={<FaPlus />}
          isLoading={mutation.isLoading}
          onClick={() => mutation.mutate(id as number)}
          variant={'solid'}
          colorScheme={'green'}
        >
          Criar
        </Button>
      </HStack>
    </VStack>
  );
}
